import logo from './logo.svg';
import './App.css';
        
import { BrowserRouter,Switch,Route } from 'react-router-dom';
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import Homepage from './Component/Homepage/Homepage';
import Service from './Component/Service/Service';
import About from './Component/About/About';
import Contact from './Component/Contact/Contact';
import Notfound from './Component/Notfound/Notfound';

function App() {
  return (
    
      <div className="App">
        <BrowserRouter>
            <Header/>
        <Switch>

            <Route exact path="/home">
                <Homepage></Homepage>
            </Route>
            <Route exact path="/service">
                <Service></Service>
            </Route>
            <Route exact path="/about">
                <About></About>
            </Route>
            <Route exact path="/contact">
                <Contact></Contact>
            </Route>
            <Route exact path="/">
                <Homepage></Homepage>
            </Route>
            
            <Route path="*">
                <Notfound></Notfound>
            </Route>
            

        </Switch>
        <Footer/>
      
      
      </BrowserRouter>
      </div>
    
  );
}

export default App;
